import { ComponentQuery } from 'models';

import { componentSearchFilters } from 'components/component-overview/state/component-search-filters';
import { useSnapshot } from 'hooks/use-safe-snapshot';

const useComponentSearchFilters = (): ComponentQuery => {
    return useSnapshot(componentSearchFilters);
};

export { useComponentSearchFilters };
